


















































import { Component, Vue, Prop, Model } from 'vue-property-decorator'
import {
  getDocumentListRequest,
  GetDocInfoById,
  getDocInfoForEidt,
} from '@/api/supervision'
import TinymceEditor from '@/components/TinymceEditor'

@Component({
  components: { TinymceEditor },
})
export default class DocumentModal extends Vue {
  @Prop({ type: Boolean }) readonly visible!: boolean;
  @Prop({ type: Object }) docData!: any;
  @Prop({ type: String }) readonly action!: any;
  @Prop({ type: Boolean }) readonly reset!: boolean;
  @Prop({ type: Boolean }) readonly isInfo!: boolean;
  @Prop({ type: Number }) readonly   editIndex!: Number;


  private documentList: any = [];
  private documentInfo: any = {
    documentName: undefined,
    documentContent: '',
    documentIssueState: '',
    documentIssueTime: '',
    id: '',
    enterpriseUploadFlag: 0,
  };
  private disabled: Boolean = false;
  private setContent: any;
  created() {
    if (this.isInfo) {
      this.disabled = true
      this.$nextTick(() => {
        this.setContent = this.$refs.editor
        this.setContent.setMode()
        // console.log(this.setContent.activeEditor)
      })
    }
    getDocumentListRequest('12345').then((res: any) => {
      if (res && res.status === 0) {
        this.documentList = res.data
      } else {
        this.$message.error(res.message)
      }
    })
  }
  content: any = '';
  private isEdit:Boolean = false

  mounted() {
    this.$nextTick(() => {
      this.setContent = this.$refs.editor
      if (this.docData&&this.docData.documentName) {
        this.isEdit = true
      if(this.isInfo){
        this.disabled = true
      } else{
        this.disabled = false
      }
        (this.documentInfo.documentName = {
          key: this.docData.documentId,
          label: this.docData.documentName,
        }),
        this.setContent.setContent(this.docData.documentContent),
        this.documentInfo.documentId = this.docData.documentId,
        this.documentInfo.isEdit = true,
        this.documentInfo.enterpriseUploadFlag =this.docData.enterpriseUploadFlag,
        this.documentInfo.documentURL = this.docData.documentURL,
        this.documentInfo.id = this.docData.id,
        this.documentInfo.sendFlag = this.docData.sendFlag,
        this.documentInfo.sendStatus = this.docData.sendStatus,
        this.documentInfo.sendTime = this.docData.sendTime,
        this.documentInfo.uploadStatus = this.docData.uploadStatus,
        this.documentInfo.uploadTime = this.docData.uploadTime,
        this.documentInfo.sendStatus = this.docData.sendStatus
        this.documentInfo.editIndex = this.docData.editIndex
      } else {
        this.documentInfo.isEdit = false
      }
    })
  }
  private getDocContent(e: any) {
    GetDocInfoById(e).then((res: any) => {
      if (res && res.status === 0) {
        setTimeout(() => {
          this.setContent = this.$refs.editor
          this.setContent.setContent(res.data.content)
        }, 300)
        this.documentInfo.documentIssueState = res.data.documentIssueState
        this.documentInfo.documentIssueTime = res.data.documentIssueTime
        this.documentInfo.documentId = res.data.id
        // this.$nextTick(() => {
        //   this.setContent = this.$refs.editor
        //   this.setContent.setContent(res.data.content)
        // })
      } else {
        this.$message.error(res.message)
      }
    })
  }
  handleOk() {
    const _this = this
    if (!this.documentInfo.documentName) {
      this.$message.warning('请先选择一个文书模板')
      return
    }
    if (this.setContent.value === '') {
      this.$message.warning('请填写模板内容')
      return
    }
    if(this.action === 'update'){
       var docData =_this.documentInfo
       docData.documentContent = this.setContent.value
       docData.documentName = _this.documentInfo.documentName.label.trim()
    } else {


    var docData:any = {
      documentName: _this.documentInfo.documentName.label.trim(),
      documentContent: this.setContent.value,
      //  documentIssueTime:this.documentInfo.documentIssueTime,
      //  documentIssueState:this.documentInfo.documentIssueState,
      documentId: this.documentInfo.documentId,
      enterpriseUploadFlag: this.documentInfo.enterpriseUploadFlag,
      isEdit: this.documentInfo.isEdit,
      sendStatus:this.documentInfo.sendStatus,
      sendFlag:this.documentInfo.sendFlag,
      editIndex:this.documentInfo.editIndex
    }    }
  
    this.$emit('docCallBack', docData)

    this.$emit('closeDoc')
  }
  handleCancel() {
    this.documentInfo.documentName = undefined
    this.$emit('closeDoc')
  }
  private handleChange(e: any) {
    this.getDocContent(e.key)
  }
}
